{
  "welcome": "ਜੀ ਆਇਆਂ ਨੂੰ",
  "instructions": "ਆਪਣੀ ਚੈੱਕ-ਇਨ ਪ੍ਰਕਿਰਿਆ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਹੇਠਾਂ ਟੈਪ ਕਰੋ।",
  "startCheckIn": "ਚੈੱਕ-ਇਨ ਸ਼ੁਰੂ ਕਰੋ",
  "missingWarehouseTitle": "ਗੁਦਾਮ ਗੁੰਮ ਹੈ",
  "missingWarehouseMessage": "ਲਿੰਕ ਅਵੈਧ ਹੈ, ਇਸ ਵਿੱਚ ਗੁਦਾਮ ID ਸ਼ਾਮਲ ਹੋਣੀ ਲਾਜ਼ਮੀ ਹੈ",
  "recaptchaAttribution": "ਇਹ ਸਾਈਟ reCAPTCHA ਦੁਆਰਾ ਸੁਰੱਖਿਅਤ ਹੈ ਅਤੇ Google ਦੀ {privacyPolicy} ਅਤੇ {termsOfService} ਲਾਗੂ ਹੁੰਦੀ ਹੈ।",
  "recaptchaPrivacyPolicy": "ਪਰਦੇਦਾਰੀ ਨੀਤੀ",
  "recaptchaTermsOfService": "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
  "lookupTitle": "ਆਪਣੀ ਮੁਲਾਕਾਤ ਲੱਭਣ ਲਈ ਹਵਾਲਾ ਨੰਬਰ ਜਾਂ ਪੁਸ਼ਟੀ ਨੰਬਰ ਸ਼ਾਮਲ ਕਰੋ",
  "referenceNumberLabel": "ਹਵਾਲਾ ਨੰਬਰ ਜਾਂ ਪੁਸ਼ਟੀ ਨੰਬਰ",
  "referenceNotFoundError": "ਹਵਾਲਾ ਜਾਂ ਪੁਸ਼ਟੀ ਨੰਬਰ ਕਿਸੇ ਵੀ ਵੈਧ ਮੁਲਾਕਾਤ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦਾ।",
  "checkIn": "ਚੈੱਕ-ਇਨ ਕਰੋ",
  "loadTypeLabel": "ਲੋਡ ਦੀ ਕਿਸਮ",
  "directionLabel": "ਦਿਸ਼ਾ",
  "operationLabel": "ਸੰਚਾਲਨ",
  "dockLabel": "ਡੌਕ",
  "orDivider": "ਜਾਂ",
  "noReferenceTitle": "ਮੇਰੇ ਕੋਲ ਪੁਸ਼ਟੀ ਨੰਬਰ ਨਹੀਂ ਹੈ",
  "noReferenceDescription": "ਮਿਆਰੀ ਚੈੱਕ-ਇਨ ਪ੍ਰਕਿਰਿਆ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹੋਏ ਬਿਨਾਂ ਮੁਲਾਕਾਤ ਦੇ ਅੱਗੇ ਵਧੋ।",
  "checkInWithoutAppointment": "ਬਿਨਾਂ ਮੁਲਾਕਾਤ ਦੇ ਚੈੱਕ-ਇਨ ਕਰੋ",
  "readyToCheckInTitle": "ਚੈੱਕ-ਇਨ ਲਈ ਤਿਆਰ ਹੋ?",
  "readyToCheckInDescription": "ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਹੇਠਾਂ ਟੈਪ ਕਰੋ। ਤੁਸੀਂ ਅਗਲੀ ਸਕ੍ਰੀਨ 'ਤੇ ਆਪਣੇ ਵੇਰਵੇ ਦਰਜ ਕਰੋਗੇ।",
  "referenceRequiredHint": "ਇਸ ਟਿਕਾਣੇ 'ਤੇ ਚੈੱਕ-ਇਨ ਕਰਨ ਲਈ ਹਵਾਲਾ ਨੰਬਰ ਲੋੜੀਂਦਾ ਹੈ।",
  "haveAppointment": "ਮੇਰੇ ਕੋਲ ਮੁਲਾਕਾਤ ਹੈ",
  "direction": {
    "inbound": "ਇਨਬਾਊਂਡ",
    "outbound": "ਆਊਟਬਾਊਂਡ",
    "inOut": "ਇਨਬਾਊਂਡ ਅਤੇ ਆਊਟਬਾਊਂਡ",
    "load": "ਲੋਡਿੰਗ",
    "unload": "ਅਨਲੋਡਿੰਗ"
  },
  "operation": {
    "live": "ਲਾਈਵ",
    "drop": "ਡਰਾਪ",
    "other": "ਹੋਰ"
  }
}
